// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vzZA","requiredAsterisk":"Info_requiredAsterisk__2Pam2"};